import { message } from "antd";
import { put } from "redux-saga/effects";
import { logoutRequest } from "../feature/auth/authSlice";
import { GENERAL_CODE } from "./message";

export function* handleErrorSaga(error, typeError) {
  if (error?.response?.data?.statusCode === 401) {
    yield put(logoutRequest());
  } else {
    if (error?.response?.data?.code) {
      message.error(
        typeError
          ? typeError[error.response.data.code]
          : GENERAL_CODE[error.response.data.code] || error.response.data.code,
        5
      );
    } else {
      error?.response?.data
        ? console.log(error.response.data)
        : console.log(error);
    }
  }
}

export const typeError = (payload) =>
  GENERAL_CODE[payload.response.data.code] || payload.response.data.code;

export const parseToMoney = (value, negative) => {
  if (negative)
    return value >= 0
      ? `- $${value.toFixed(2)}`
      : `- $${(value * -1).toFixed(2)}`;
  return value >= 0 ? `$${value.toFixed(2)}` : `- $${(value * -1).toFixed(2)}`;
};
